import React, { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Chip,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import baseURL from '../../../config';
import dayjs from 'dayjs';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DepartureModal = ({ departureDetails = [] }) => {
  const [pdfUrl, setPdfUrl] = useState('');
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [loadingCrewId, setLoadingCrewId] = useState(null);

  const handleSendRequest = async (crewId) => {
    if (!crewId) return;

    try {
      setLoadingCrewId(crewId);

      // Simulate API request
      await new Promise((resolve) => setTimeout(resolve, 2000));

      toast.error(`Request sent for Crew ID: ${crewId}`);
    } catch (error) {
      console.error("Request failed", error);
    } finally {
      setLoadingCrewId(null);
    }
  };

  const handleViewPdf = (crewId) => {
    if (!crewId) {
      toast.error("Crew ID not found.");
      return;
    }

    setPdfUrl(`${baseURL}/api/pdf/sea-service/${crewId}`);
    setOpenPdfModal(true);
  };

  return (
    <>
      <Paper elevation={3} sx={{ p: 2 }}>
        {departureDetails.length > 0 ? (
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Departure Details</TableCell>
                {/* <TableCell sx={{ fontWeight: "bold", width: 250 }}>Sea Service </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {departureDetails.map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold">
                      <strong style={{ color: "black" }}>Vessel Name:</strong>{" "}
                      {item.contractDetails?.ShipDetails?.vesselname || "N/A"}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        flexWrap: "wrap",
                        marginTop: 1,
                      }}
                    >
                      <Chip
                        size="small"
                        label={`Crew: ${item.contractDetails?.crewdetails?.name || "N/A"}`}
                        sx={{ bgcolor: "#e3f2fd", color: "#0d47a1" }}
                      />
                      <Chip
                        size="small"
                        label={`Indos No.: ${item.contractDetails?.crewdetails?.indosno || "N/A"}`}
                        sx={{ bgcolor: "#fff9c4", color: "#f57f17" }}
                      />
                      {/* <Chip
                        size="small"
                        label={`Agent: ${item.contractDetails?.crewingAgent?.agentName || "N/A"}`}
                        sx={{ bgcolor: "#fff9c4", color: "#f57f17" }}
                      /> */}
                      <Chip
                        size="small"
                        label={`Port Name: ${item.contractStatusAfterForm1?.departure?.[0]?.portName || "N/A"}`}
                        sx={{ bgcolor: "#e8f5e9", color: "#1b5e20" }}
                      />
                      <Chip
                        size="small"
                        label={`Arrival Date: ${
                          item.contractStatusAfterForm1?.departure?.[0]?.date
                            ? dayjs(item.contractStatusAfterForm1.departure[0].date).format("DD-MM-YYYY")
                            : "N/A"
                        }`}
                        sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                      />
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      {/* <Button
                        variant="contained"
                        onClick={() => handleViewPdf(item.contractDetails?.crewdetails?._id)}
                      >
                        View
                      </Button> */}
                      {/* <Button
                        variant="outlined"
                        disabled={loadingCrewId === item.contractDetails?.crewdetails?._id}
                        onClick={() => handleSendRequest(item.contractDetails?.crewdetails?._id)}
                        startIcon={
                          loadingCrewId === item.contractDetails?.crewdetails?._id ? (
                            <CircularProgress size={16} />
                          ) : null
                        }
                      >
                        {loadingCrewId === item.contractDetails?.crewdetails?._id
                          ? "Sending..."
                          : "Send Request"}
                      </Button> */}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography color="textSecondary" align="center">
            No departure details found.
          </Typography>
        )}
      </Paper>

      {/* PDF Modal */}
      {/* <Dialog open={openPdfModal} onClose={() => setOpenPdfModal(false)} maxWidth="md" fullWidth>
        <DialogTitle>Sea Service PDF</DialogTitle>
        <DialogContent dividers>
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              width="100%"
              height="600px"
              style={{ border: "none" }}
            />
          ) : (
            <Typography>No PDF to display.</Typography>
          )}
        </DialogContent>
      </Dialog> */}

      <ToastContainer />
    </>
  );
};

export default DepartureModal;
